import Text from '../../../../elements/Typo/Text'
import Button from '../../../../elements/button'
import Icon from '../../../../components/icons'
import React, { useEffect, useRef, useState } from 'react'
import ExperimentReviewModal from './modal/experimentReview.modal'
import Groups from './group'
import GraphData from './graphData'
import AvgMetricDesign from './avgMetricDesign'
import { useExperimentSelector } from '../../../../store/selectors/experimentSelector'
import { useExperimentApi } from '../../../../store/api/hooks/experimentApiHook'
import { useNavigate, useParams } from 'react-router-dom'
import { URLS } from '../../../../_config'
import { useDialog } from '../../../../store/api/hooks/dialogHook'
import toast from 'react-hot-toast'
import RCTMeasurementModal from './modal/RCT/measurement.modal'
import MteMeasurementModal from './modal/MTE/mteMeasurement.modal'
import MteConfigureMeasurementDataModal from './modal/MTE/mteConfigureMeasurementData.modal'
import MTEMeasurementDataModal from './modal/MTE/measurementData.modal'
import RCTMeasurementDataModal from './modal/RCT/measurementData.modal'
import Loader from '../../../../components/loader'
import RCTMultiFileMeasurementModal from './modal/RCT/RCTMultiFileMeasurement.modal'
import RCTMultiFileMeasurementConfigureModal from './modal/RCT/RCTMultiFileMeasurementConfigure.modal'
import { SuccessResponse, ErrorResponse } from '../../../../store/api/apiTypes'
import { CANCEL_EXPERIMENT_STEP, EXPERIMENT_TYPES, GRAPH_FAILED_MESG } from '../../../../_common/constant'
import CommentButton from './commentButton'
import DirectMeasurementFlowModal from '../../../Measurement/modal/directMeasurementFlow.modal'
import DownloadButton from '../../components/DownloadButton'
import LineData from './oStudy/lineData'
import moment from 'moment'
import { useTranslation } from 'react-i18next'
import P from '../../../../elements/Typo/P'
import { trackEvent } from '../../../../_common/functions'
import { useFpLoader } from '../../../../store/api/hooks/fpLoaderHook'
import { LiaCrosshairsSolid, LiaDotCircle } from 'react-icons/lia'
import { HiUsers } from 'react-icons/hi'

const GraphMsgRender = (graphs: any, failed: boolean, t: any) => {
    if (graphs == GRAPH_FAILED_MESG) {
        return null
    } else {
        return (
            <div className="my-8">
                {failed ? (
                    <div className="flex items-center justify-center p-4 bg-red-200 rounded-lg border border-red-500">
                        <Text size="19" className="font-semibold">
                            {t('Design for observational study failed')}
                        </Text>
                    </div>
                ) : (
                    <Loader />
                )}
            </div>
        )
    }
}

interface ApiResponseI {
    data: any
    message: string
    status_code: number
    success: boolean
}

interface Props {
    getKpiTypes: any
    getColumns: any
}

const downloadCsvBlob = (blob: Blob, fileName: string) => {
    const url = globalThis.URL.createObjectURL(blob)
    const link = document.createElement('a')
    link.href = url
    link.setAttribute('download', fileName)
    document.body.appendChild(link)
    link.click()
    link.remove()
    globalThis.URL.revokeObjectURL(url)
}

export const decompressAndDownload = async (resp: any, fileName: string) => {
    const gzipBlob = new Blob([resp])
    const decompressedStream = gzipBlob.stream().pipeThrough(new DecompressionStream('gzip'))
    const decompressedBlob = await new Response(decompressedStream).blob()

    const csvBlob = new Blob([decompressedBlob], { type: 'text/csv;charset=utf-8;' })
    downloadCsvBlob(csvBlob, fileName)
}

const Allocation: React.FC<Props> = ({ getKpiTypes, getColumns }) => {
    const { t } = useTranslation()
    const params: any = useParams()
    const experimentAPI: any = useExperimentApi()
    const experiment: any = useExperimentSelector()
    const { confirm: confirmDialog } = useDialog()
    const experimentReviewModalRef: any = useRef()
    const contentRef: any = useRef<HTMLDivElement | null>(null)
    const [groups, setGroups] = useState<any[] | null>(null)
    const [graphs, setGraphs] = useState<any>(null)
    const [isGraphExecuting, setIsGraphExecuting] = useState<boolean>(false)
    const [working, setWorking] = useState<boolean>(true)
    const [totalGroupSize, setTotalGroupSize] = useState<number>(0)
    const [measurementTableData, setMeasurementTableData] = useState<any>(null)
    const dialog = useDialog()
    const navigate = useNavigate()
    const measurementModalRef: any = useRef()
    const directMeasurementFlowModalRef: any = useRef()
    const measurementDataModalRef: any = useRef()
    const mteConfigureMeasurementDataModalRef: any = useRef()
    const [conversionFlow, setConversionFlow] = useState<boolean>(false)
    const [avgMetricLoading, setAvgMetricLoading] = useState<boolean>(false)
    const [failed, setFailed] = useState<boolean>(false)
    const [lineCharts, setLineCharts] = useState<any>(null)
    const pollingTimeoutRef = useRef<NodeJS.Timeout | null>(null)
    const { showLoader, hideLoader } = useFpLoader()

    const [avgMetricDesign, setAvgMetricDesign] = useState<{
        kpi: string
        data: any[] | null
    }>({
        kpi: '',
        data: [],
    })

    const getExperimentDetails = () => {
        return new Promise((resolve, reject) => {
            experimentAPI.getExperimentDetails(
                { literal: params.experiment + '?use_orm=true&cache=' + Date.now() },
                (resp: any) => {
                    resolve(resp.data)
                },
                (error: any) => {
                    reject(error)
                },
            )
        })
    }

    const getRctGroupResultSWatch = (n: number) => {
        experimentAPI.getExperimentDetails(
            { literal: params.experiment + '?use_orm=true' },
            (resp: any) => {
                const _experiment: any = resp.data
                if (_experiment?.experiment_metadatas?.design_data_quality_report?.output_file_name) {
                    getExperimentDetails().catch((error) => {
                        console.error('Error fetching experiment details:', error)
                    })
                } else {
                    pollingTimeoutRef.current = setTimeout(() => {
                        getRctGroupResultSWatch(n + 1)
                    }, 2000)
                }
            },
            (error: any) => {},
        )
    }

    const collectGroupInformation = (data: any) => {
        return data.map((item: any) => {
            return {
                ...item,
                group: experiment?.experiment_metadatas.group_configs.find((gr: any) => gr.name === item.name),
            }
        })
    }

    const _handleFetchAvgMetric = () => {
        setAvgMetricLoading(true)
        experimentAPI.getAvgMetricDesign(
            {
                literal: params.experiment,
            },
            (resp: any) => {
                setAvgMetricLoading(false)
                if (resp.data) {
                    const key: string[] = Object.keys(resp.data)
                    const _data: any = resp.data[key[0]]
                    setAvgMetricDesign({
                        kpi: key[0],
                        data: collectGroupInformation(_data),
                    })
                } else {
                    setAvgMetricDesign({
                        kpi: '',
                        data: null,
                    })
                }
            },
            (error: any) => {
                setAvgMetricLoading(false)
                setAvgMetricDesign({
                    kpi: '',
                    data: null,
                })
                toast.error(error.message)
            },
        )
    }

    const getGroups = (data: any) => {
        return data
            .map((_group: any, indexval: number) => {
                let total = 0
                let is_control = false
                experiment?.experiment_metadatas?.group_configs.map((gr: any) => {
                    if (gr.name == _group.group_name) {
                        total = gr.group_size
                        is_control = gr.is_control
                    }
                })
                return {
                    name: _group.group_name,
                    value: total == 0 ? 0 : Math.round(_group.count / (total / 100)), //we need sample size and calculate percentage here..
                    count: _group.count,
                    is_control,
                }
            })
            .filter((__gr: any) => {
                if (__gr.name == 'No Level') {
                    return false
                } else {
                    return true
                }
            })
            .sort((a: any, b: any) => {
                if (a.is_control !== b.is_control) {
                    return a.is_control - b.is_control
                }
                return a?.name?.localeCompare(b.name)
            })
    }

    const buildRctGraphData = (data: any): { graphs: any; show: number } => {
        let show = 1
        const graphs: any = {}
        for (const interName of Object.keys(data)) {
            graphs[interName] = {}
            if (Object.keys(data[interName]).length == 0) {
                show = 0
            } else {
                for (const graphName of Object.keys(data[interName])) {
                    graphs[interName][graphName] = Object.keys(data[interName][graphName]).map((name: string) => ({
                        name,
                        groups: getGroups(data[interName][graphName][name]),
                    }))
                }
            }
        }
        return { graphs, show }
    }

    const getRctGroupResultS = () => {
        experimentAPI.executerctresult(
            { literal: params.experiment },
            (resp: any) => {
                const { graphs: _graphs, show } = buildRctGraphData(resp.data)
                setGraphs(show == 1 ? _graphs : GRAPH_FAILED_MESG)

                setWorking(false)
                setIsGraphExecuting(false)
            },
            (err: any) => {
                setGraphs(`${experiment.experiment_type.title} ${t('Executing...')}`)
                setIsGraphExecuting(true)
            },
        )
    }

    const getDownloadFilename = () => {
        return experiment?.experiment_type?.title == 'Observational Study' ? `${params.experiment}_Matching_Result.csv` : `${params.experiment}_RCT_Result.csv`
    }

    const exportRctGroupResultS = () => {
        showLoader()
        const hasGzipFile = experiment?.experiment_metadatas?.design_data_quality_report?.output_gzip_file_name

        if (hasGzipFile) {
            experimentAPI.downloadRctGZipResults(
                {
                    literal: params.experiment,
                },
                (resp: any) => {
                    hideLoader()
                    decompressAndDownload(resp, getDownloadFilename()).catch(() => {
                        toast.error(t('Failed to decompress file. Please try again.'))
                    })
                    /* const gzipBlob = new Blob([resp])
                    const ds = new DecompressionStream('gzip')
                    const decompressedStream = gzipBlob.stream().pipeThrough(ds)
                    const reader = decompressedStream.getReader()
                    const chunks: any[] = []

                    const readAll = (): Promise<void> =>
                        reader.read().then(({ done, value }) => {
                            if (done) return
                            chunks.push(value)
                            return readAll()
                        })

                    readAll()
                        .then(() => {
                            const csvBlob = new Blob(chunks, { type: 'text/csv;charset=utf-8;' })
                            const url = globalThis.URL.createObjectURL(csvBlob)
                            const link = document.createElement('a')
                            link.href = url
                            if (experiment?.experiment_type?.title == 'Observational Study') {
                                link.setAttribute('download', `${params.experiment}_Matching_Result.csv`)
                            } else {
                                link.setAttribute('download', `${params.experiment}_RCT_Result.csv`)
                            }
                            document.body.appendChild(link)
                            link.click()
                            link.remove()
                            globalThis.URL.revokeObjectURL(url)
                        })
                        .catch(() => {
                            toast.error(t('Failed to decompress file. Please try again.'))
                        }) -- back */
                },
                (err: any) => {
                    hideLoader()
                    toast.error(err?.message || t('Failed to download files. Please try again later.'))
                },
            )
        } else {
            experimentAPI.downloadrctresult(
                {
                    literal: params.experiment,
                },
                (resp: any) => {
                    hideLoader()
                    const csvContent = resp
                    const blob = new Blob([csvContent], { type: 'text/csv;charset=utf-8;' })
                    downloadCsvBlob(blob, getDownloadFilename())
                },
                (err: any) => {
                    hideLoader()
                    toast.error(err?.message || t('Failed to download files. Please try again later.'))
                },
            )
        }
    }

    const cancelExperiment = () => {
        experimentAPI.cancelExperiment(
            {
                literal: params.experiment,
                step: CANCEL_EXPERIMENT_STEP.DESIGN,
            },
            (resp: SuccessResponse<ApiResponseI>) => {
                toast.success(resp.message)
                void navigate(`${URLS.CREATE_EXPERIMENT(params.experiment)}?step=3`)
            },
            (error: ErrorResponse<ApiResponseI>) => {
                toast.error(error.message)
            },
        )
    }

    const createGroupData = (data: any, viewType: string) => {
        const groupedData: any = data.reduce((acc: any, item: any) => {
            const date = moment(item.Date)
            let dateKey = `${date.clone().startOf('isoWeek').format('DD-MMM')} - ${date.clone().endOf('isoWeek').format('DD-MMM')}, ${date.year()}` // Group by week
            if (viewType == 'monthly') {
                dateKey = date.format('MMM YYYY')
            }
            const valueKeys = Object.keys(item).filter((key) => key !== 'Date')
            if (!acc[dateKey]) {
                acc[dateKey] = { Date: dateKey }
                for (const key of valueKeys) {
                    acc[dateKey][key] = 0 // Initialize group values
                }
            }
            for (const key of valueKeys) {
                acc[dateKey][key] = Number((acc[dateKey][key] + (item[key] || 0)).toFixed(2)) // Sum up group values
            }
            return acc
        }, {})

        return Object.values(groupedData)
    }

    const getGroupResultSWatch = () => {
        experimentAPI.getExperimentDetails(
            { literal: params.experiment + '?use_orm=true' },
            (resp: any) => {
                const _experiment: any = resp.data
                const qualityReport: any = _experiment?.experiment_metadatas?.design_data_quality_report
                if (qualityReport?.design_execution_status?.status == 'obs_dtw_completion') {
                    console.log('obs_dtw_completion')
                } else if (qualityReport.design_execution_status?.status == 'obs_dtw_failure') {
                    setFailed(true)
                } else {
                    setTimeout(() => {
                        getGroupResultSWatch()
                    }, 2000)
                }
            },
            (error: any) => {},
        )
    }

    const makeGroups = (resp: any, interName: string, barKey: string) => {
        return experiment?.experiment_metadatas?.interventions[0]?.group_configs
            .map((_group: any, indexval: number) => {
                let count = 0
                let value = 0
                resp.data[interName][barKey].map((gr: any) => {
                    if (gr.group_name == _group.name) {
                        count = gr.count
                        value = gr.percentage
                    }
                })

                return {
                    name: _group.name,
                    value,
                    count,
                    is_control: _group.is_control,
                }
            })
            .filter((__gr: any) => {
                if (__gr.name == 'No Level') {
                    return false
                } else {
                    return true
                }
            })
            .sort((a: any, b: any) => {
                if (a.is_control !== b.is_control) {
                    return a.is_control - b.is_control
                }
                return a.name.localeCompare(b.name)
            })
    }

    const buildDistributionGraphData = (data: any): { graphs: any; show: number } => {
        let show = 1
        const graphs: any = {}
        for (const interName of Object.keys(data || [])) {
            graphs[interName] = []
            if (Object.keys(data[interName]).length == 0) {
                show = 0
            } else {
                graphs[interName] = Object.keys(data[interName]).map((barKey: string) => ({
                    name: barKey,
                    groups: makeGroups({ data }, interName, barKey),
                }))
            }
        }
        return { graphs, show }
    }

    const distributionChartHandler = (resp: any, show: number) => {
        experimentAPI.getExperimentDetails(
            { literal: params.experiment + '?use_orm=true' },
            (resp: any) => {},
            (error: any) => {},
        )
        console.log('bar chart--', resp)
        const result = buildDistributionGraphData(resp?.data)

        setGraphs(result.show == 1 ? result.graphs : GRAPH_FAILED_MESG)
        setWorking(false)
        setIsGraphExecuting(false)
    }

    const getOstudyBarChartResultS = () => {
        const show = 1
        experimentAPI.Getobsfeaturedistributionbarchart(
            { literal: params.experiment },
            (resp: any) => {
                distributionChartHandler(resp, show)
            },
            (err: any) => {
                setGraphs(`${experiment.experiment_type.title} ${t('Executing...')}`)
                setIsGraphExecuting(true)
            },
        )
    }

    const transformLineChartEntry = (entry: any, viewType: string) => {
        const baseFields = {
            top: entry.yAxis.max,
            bottom: entry.yAxis.min,
            right: entry.data.length,
            left: 0,
            refAreaRight: '',
            refAreaLeft: '',
        }
        const isDatePresent = !!entry.data[0].Date
        if (isDatePresent && (viewType == 'weekly' || viewType == 'monthly')) {
            return { ...entry, data: createGroupData(entry.data, viewType), ...baseFields }
        }
        return { ...entry, ...baseFields }
    }

    const getOstudyLineChartResultS = () => {
        const show = 1
        experimentAPI.Getkpichartdatabydate(
            { literal: params.experiment },
            (resp: any) => {
                if (!resp.data) return
                const viewType = experiment?.experiment_metadatas?.design_column_map?.date_frequency
                for (const intervensionName of Object.keys(resp.data)) {
                    resp.data[intervensionName] = transformLineChartEntry(resp.data[intervensionName], viewType)
                }
                setLineCharts(resp.data)
            },
            (err: any) => {
                //setGraphs(`${experiment.experiment_type.title} Executing...`)
            },
        )
    }

    const setDataFromExperiment = () => {
        if (experiment.experiment_metadatas?.metrices != null) {
            let flow: boolean = false
            experiment.experiment_metadatas?.metrices.map((kpi: any) => {
                if (kpi.literral_value == 'Incremental Conversion') {
                    flow = true
                }
            })
            setConversionFlow(flow)
        }
        if (experiment?.experiment_metadatas?.total_group_size) {
            setTotalGroupSize(experiment?.experiment_metadatas?.total_group_size)
        }

        if (experiment?.experiment_metadatas?.design_data_quality_report?.output_file_name) {
            if (graphs == null || typeof graphs != 'object') {
                if (experiment.experiment_type.title == 'RCT' || experiment.experiment_type.title == 'Post-Treatment Comparison') {
                    getRctGroupResultS()
                } else {
                    getOstudyBarChartResultS()
                    getOstudyLineChartResultS()
                }
            }
        } else if (experiment?.status_text == 'Failed' && experiment?.step == 4) {
            setGraphs('')
            setWorking(false)
            setFailed(true)
        } else {
            setGraphs(`${experiment.experiment_type.title} ${t('Executing...')}`)
            setIsGraphExecuting(true)
        }

        if (experiment?.experiment_metadatas?.interventions[0].group_configs) {
            const cloneFn = (obj: any) => {
                if (typeof globalThis.structuredClone === 'function') {
                    return globalThis.structuredClone(obj)
                }
                return [...obj]
            }

            const gr: any = cloneFn(experiment?.experiment_metadatas?.interventions[0].group_configs)
            gr?.sort((a: any, b: any) => {
                if (a.is_control !== b.is_control) {
                    return a.is_control - b.is_control
                }
                return a?.name?.localeCompare(b.name)
            })
            setGroups(gr)
        }
    }

    useEffect(() => {
        if (experiment) {
            setDataFromExperiment()
            _handleFetchAvgMetric()
        }
    }, [experiment])

    useEffect(() => {
        const channel1 = new BroadcastChannel('OSTUDY_RESPONSE')
        const handleMessage1 = (event: MessageEvent) => {
            if (event.data.type === 'OSTUDY' && event.data.id == params.experiment) {
                getGroupResultSWatch()
                _handleFetchAvgMetric()
            }
        }

        channel1.addEventListener('message', handleMessage1)

        const channel = new BroadcastChannel('RCT_RESPONSE')
        const handleMessage = (event: MessageEvent) => {
            if (event.data.type === 'RCT' && event.data.id == params.experiment) {
                getRctGroupResultSWatch(1)
                _handleFetchAvgMetric()
            }
        }

        channel.addEventListener('message', handleMessage)

        return () => {
            channel1.removeEventListener('message', handleMessage1)
            channel.removeEventListener('message', handleMessage)
            channel1.close()
            channel.close()

            if (pollingTimeoutRef.current) {
                clearTimeout(pollingTimeoutRef.current) // STOP POLLING
            }
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [])

    let grp_sum = 0
    experiment?.experiment_metadatas?.interventions[0]?.group_configs?.map((group: any, i: any) => {
        grp_sum += group.group_size
    })

    const avgMatricOrLoading = () => {
        if (graphs == GRAPH_FAILED_MESG) {
            const notAbTest: boolean = experiment?.experiment_type?.title != 'Post-Treatment Comparison'
            if (notAbTest) {
                return <AvgMetricDesign data={avgMetricDesign.data} kpi={avgMetricDesign.kpi} className="graph-container" loading={avgMetricLoading} />
            } else {
                return null
            }
        } else {
            return (
                <div className="my-8" data-testid="graph-loading">
                    <Loader />
                </div>
            )
        }
    }

    return (
        <div>
            <div ref={contentRef} data-testid="allocation-content">
                <div className="flex items-center justify-between mb-4">
                    <div className="relative flex items-center gap-2">
                        <div className="absolute -left-5 top-0 h-full w-2 bg-primary rounded-e-md"></div>
                        <P className="!mb-0 font-semibold">{experiment?.experiment_name}</P>
                    </div>
                </div>
                <div className="relative">
                    <div className="flex items-center justify-center">
                        <div className="space-y-0.5 text-center mb-3" id="pdf-header" data-testid="pdf-header">
                            <Text size="lg1" className={`font-semibold ${working ? 'opacity-50' : ''}`} data-testid="allocation-title">
                                {t('Group Allocation Complete')}
                            </Text>
                            <Text size="sm" className={`${working ? 'opacity-50' : ''}`} data-testid="allocation-subtitle">
                                {t('Your Group Allocation Results are Ready...')}
                            </Text>
                        </div>
                    </div>
                    <CommentButton experiment={experiment} className="absolute top-[50%] right-0 translate-y-[-50%]" />
                </div>

                {experiment?.experiment_type?.title == 'Observational Study' && (
                    <div className="my-2 border border-primary py-2 grid grid-cols-3 rounded-md">
                        <div className="h-full flex gap-2 items-center px-2">
                            <div className="h-6 w-6 bg-gray-200 flex items-center justify-center rounded-full">
                                <LiaDotCircle />
                            </div>
                            <div className=" leading-[1.5]">
                                <p className="text-[0.542rem]">{t('Matching Score')}</p>
                                {experiment?.experiment_metadatas?.design_config?.matching_score?.match_score ? (
                                    <p className="text-[0.75rem] font-bold">
                                        {(() => {
                                            const score = Number(experiment?.experiment_metadatas?.design_config?.matching_score?.match_score || '0')
                                            return Number.isInteger(score) ? score : score.toFixed(2)
                                        })()}{' '}
                                        <span className="font-normal text-[0.667rem]"></span>
                                    </p>
                                ) : (
                                    <p className="text-[0.75rem] font-bold">&mdash;</p>
                                )}
                            </div>
                        </div>
                        <div className="h-full flex gap-2 items-center px-2 border-l border-r border-slate-500">
                            <div className="h-6 w-6 bg-gray-200 flex items-center justify-center rounded-full">
                                <HiUsers className="text-[0.8rem]" />
                            </div>
                            <div className=" leading-[1.5]">
                                <p className="text-[0.542rem]">{t('N Matches')}</p>
                                <p className="text-[0.75rem] font-bold">{experiment?.experiment_metadatas?.design_config?.matching_score?.n_matches ?? '—'}</p>
                            </div>
                        </div>
                        <div className="h-full flex gap-2 items-center px-2">
                            <div className="h-6 w-6 bg-gray-200 flex items-center justify-center rounded-full">
                                <LiaCrosshairsSolid />
                            </div>
                            <div className=" leading-[1.5]">
                                <p className="text-[0.542rem]">{t('Caliper Used')}</p>
                                <p className="text-[0.75rem] font-bold">{experiment?.experiment_metadatas?.design_config?.matching_score?.caliper ?? '—'}</p>
                            </div>
                        </div>
                    </div>
                )}

                <div className="grid grid-cols-2 gap-3" id="pdf-groups" data-testid="group-grid">
                    {groups?.map((group: any, i: any) => (
                        <Groups ready={!working} grp_sum={grp_sum} group={group} groupTotal={totalGroupSize} key={`group-${group.name}`} />
                    ))}
                </div>

                {(experiment?.experiment_type.title == 'RCT' || experiment.experiment_type.title == 'Post-Treatment Comparison') && (
                    <>
                        {graphs !== null && typeof graphs === 'object' ? (
                            <>
                                {Object.keys(graphs).map((intervensionName: string, i: number) => (
                                    <React.Fragment key={`intervention-${intervensionName}-${i}`}>
                                        {Object.keys(graphs[intervensionName]).map((graphName: string, j: number) => (
                                            <React.Fragment key={`intervention-${i}-graph-${j}`}>
                                                <GraphData title={graphName} data={graphs[intervensionName][graphName]} className="my-4 graph-container" data-testid={`graph-${i}-${j}`} />
                                            </React.Fragment>
                                        ))}
                                    </React.Fragment>
                                ))}

                                {experiment?.experiment_type?.title != 'Post-Treatment Comparison' && <AvgMetricDesign data={avgMetricDesign.data} kpi={avgMetricDesign.kpi} className="graph-container" loading={avgMetricLoading} />}
                            </>
                        ) : (
                            avgMatricOrLoading()
                        )}
                    </>
                )}

                {experiment.experiment_type.title == 'Observational Study' && (
                    <>
                        {graphs !== null && typeof graphs === 'object' ? (
                            <>
                                {lineCharts && (
                                    <>
                                        {Object.keys(lineCharts).map((intervensionName: string, i: number) => (
                                            <LineData title={intervensionName} data={lineCharts[intervensionName]} groups={groups} key={`intervention-${intervensionName}`} />
                                        ))}
                                    </>
                                )}
                                {Object.keys(graphs).map((intervensionName: string, i: number) => (
                                    <React.Fragment key={`intervention-${intervensionName}`}>
                                        <GraphData title={intervensionName} data={graphs[intervensionName]} className="my-4 graph-container" />
                                    </React.Fragment>
                                ))}
                            </>
                        ) : (
                            GraphMsgRender(graphs, failed, t)
                        )}
                    </>
                )}

                {typeof graphs === 'string' && (
                    <div className="flex items-center justify-center my-8">
                        <Text size="19" className="font-bold">
                            {graphs}
                        </Text>
                    </div>
                )}
            </div>

            <div className={`flex items-center gap-3 my-4 ${experiment?.step >= 5 ? ' justify-center' : 'justify-between'}`}>
                {experiment?.step < 5 && (
                    <>
                        {working ? (
                            <Button
                                theme="secondary"
                                styleType="outline"
                                size="xs"
                                onClick={() => {
                                    confirmDialog({
                                        type: 'delete',
                                        title: t('Cancel Experiment'),
                                        message: t('Are you sure you want to cancel the ongoing experiment design?'),
                                        warning: t('This will stop insights generation and take you back to the group configuration page.'),
                                        onConfirm: () => cancelExperiment(),
                                        onCancel: () => {},
                                        confirmButtonLabel: t('Yes, Continue'),
                                    })
                                }}
                            >
                                {t('Cancel')}
                            </Button>
                        ) : (
                            <Button
                                theme="secondary"
                                styleType="outline"
                                size="xs"
                                disabled={failed ? !failed : typeof graphs != 'object' && graphs != 'The graph was not generated because no blocking factors were selected.'}
                                onClick={() => {
                                    void navigate(`${URLS.CREATE_EXPERIMENT(params.experiment)}?step=3`)
                                }}
                            >
                                {t('Previous Step')}
                            </Button>
                        )}
                    </>
                )}
                <div className="flex items-center gap-3">
                    <DownloadButton experiment={experiment} contentRef={contentRef} working={working} failed={failed} isGraphExecuting={isGraphExecuting} />
                    <Button theme="primary" size="xs" disabled={working || failed} onClick={exportRctGroupResultS} data-testid="download-rct-btn">
                        {experiment?.experiment_type.title == 'RCT' ? 'Download RCT' : 'Download Matching'}
                        <Icon name="download" />
                    </Button>
                    {experiment?.step < 5 && (
                        <Button
                            theme="secondary"
                            size="xs"
                            className="text-white"
                            disabled={working || failed}
                            onClick={() => {
                                trackEvent('wizard_review_modal_opened', { experiment_id: experiment?.experiment_literal })
                                experimentReviewModalRef?.current?.showModal()
                            }}
                            data-testid="submit-experiment-btn"
                        >
                            {t('Submit Experiment')}
                        </Button>
                    )}
                </div>
            </div>

            <ExperimentReviewModal
                _ref={experimentReviewModalRef}
                success={() => {
                    dialog.successExperiment({
                        onButtonClick: () => {
                            void navigate(URLS.MY_EXPERIMENTS)
                        },
                    })
                }}
                measurementModalRef={directMeasurementFlowModalRef}
            />

            <DirectMeasurementFlowModal
                _ref={directMeasurementFlowModalRef}
                onContinue={(data: any) => {
                    directMeasurementFlowModalRef?.current?.close()
                }}
            />

            {experiment?.experiment_type.title == 'RCT' && (
                <>
                    {conversionFlow ? (
                        <>
                            <RCTMultiFileMeasurementModal
                                _ref={measurementModalRef}
                                onContinue={(data: any) => {
                                    measurementModalRef?.current?.close()
                                    measurementDataModalRef?.current?.showModal()
                                }}
                            />

                            <RCTMultiFileMeasurementConfigureModal
                                _ref={measurementDataModalRef}
                                tabledata={measurementTableData}
                                literal={params.experiment || ''}
                                onPrevious={() => {
                                    measurementDataModalRef?.current?.close()
                                    measurementModalRef?.current?.showModal()
                                }}
                                onContinue={() => {
                                    measurementDataModalRef?.current?.close()
                                }}
                            />
                        </>
                    ) : (
                        <>
                            <RCTMeasurementModal
                                _ref={measurementModalRef}
                                onContinue={(data: any) => {
                                    setMeasurementTableData(data)
                                    measurementModalRef?.current?.close()
                                    measurementDataModalRef?.current?.showModal()
                                }}
                            />
                            <RCTMeasurementDataModal
                                _ref={measurementDataModalRef}
                                tabledata={measurementTableData}
                                literal={params.experiment || ''}
                                getKpiTypes={getKpiTypes}
                                getColumns={getColumns}
                                onPrevious={() => {
                                    measurementDataModalRef?.current?.close()
                                    measurementModalRef?.current?.showModal()
                                }}
                            />
                        </>
                    )}
                </>
            )}

            {experiment?.experiment_type?.title == EXPERIMENT_TYPES.MTE.title && (
                <>
                    <MteMeasurementModal
                        _ref={measurementModalRef}
                        onContinue={(data: any) => {
                            setMeasurementTableData(data)
                            measurementModalRef?.current?.close()
                            measurementDataModalRef?.current?.showModal()
                        }}
                    />

                    <MTEMeasurementDataModal
                        _ref={measurementDataModalRef}
                        tabledata={measurementTableData}
                        literal={params?.experiment ?? ''}
                        onContinue={() => {
                            measurementDataModalRef?.current?.close()
                            mteConfigureMeasurementDataModalRef?.current?.showModal()
                        }}
                        onPrevious={() => {
                            measurementDataModalRef?.current?.close()
                            measurementModalRef?.current?.showModal()
                        }}
                    />

                    <MteConfigureMeasurementDataModal
                        _ref={mteConfigureMeasurementDataModalRef}
                        tabledata={measurementTableData}
                        literal={params?.experiment ?? ''}
                        onContinue={() => {
                            mteConfigureMeasurementDataModalRef?.current?.close()
                        }}
                        onPrevious={() => {
                            measurementDataModalRef?.current?.showModal()
                            mteConfigureMeasurementDataModalRef?.current?.close()
                        }}
                    />
                </>
            )}
        </div>
    )
}

export default Allocation
